const initialState = {
  bookingResponse: null,
  email: '',
  name: '',
  id_integration: '',
  bookingDetail: { room: {} },
  pricesDetail: null,
  subsidiary: null,
  pagos: false,
  search: {},
  hotelDetails: { location: {} },
  bookingError: false,
  errorType: null,
  errorMessage: null,
};

const voucherReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_VOUCHER_INFO':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default voucherReducer;
